import { useEffect } from "react"
import { useState } from "react"
import { useToasts } from "react-toast-notifications"
import { getApiErrorMessage } from "../utils/ApiUtils"

const useFetch = (request, data) => {
  const [response, setResponse] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { addToast } = useToasts()

  useEffect(() => {
    setLoading(true)
    setError(null)
    setResponse(null)
    request(data)
      .then(res => {
        setResponse(res.data)
        setLoading(false)
      })
      .catch(err => {
        setError(err.response)
        addToast(getApiErrorMessage(err.response), {
          appearance: "error",
          autoDismiss: true
        })
        setLoading(false)
      })
  }, [addToast, request, data])

  return { response, loading, error }
}

export default useFetch
